import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KindService } from 'app/services/models/kind.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-kind-dialog',
  templateUrl: './create-kind-dialog.component.html',
  styleUrls: ['./create-kind-dialog.component.scss']
})
export class CreateKindDialogComponent implements OnInit {
  @Input() data: { title: string,  typeNumber: number };
  kindName:string;
  constructor(
    public activeModal: NgbActiveModal,
    private kindService:KindService,
    private toastrService:ToastrService
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async confirm(){
    console.log(this.kindName);
    const data = await this.kindService.createKind(this.kindName,this.data.typeNumber);
    if(data.status){
      this.toastrService.success(data.message);
      this.kindService.sendEvent(true);
      this.closeModal();
    }else{
      this.toastrService.error(data.message);
    }
  }
}
